import { render, staticRenderFns } from "./LastProjectCarousel.vue?vue&type=template&id=7f469511&"
import script from "./LastProjectCarousel.vue?vue&type=script&lang=js&"
export * from "./LastProjectCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports